// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".awsui_screen-reader-navigation-hidden_1wuib_pl8f7_1:not(#\\9){position:absolute !important;clip-path:circle(0)}.awsui_screen-reader-navigation-visible_1wuib_pl8f7_6:not(#\\9){position:fixed;background:white;padding:8px;border:1px solid black;z-index:10001}\n", ""]);
// Exports
module.exports = exports;
